"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const useShellContext_1 = require("hooks/useShellContext");
const withShellContext = (Component) => {
    return (props) => {
        const shellContext = (0, useShellContext_1.useShellContext)();
        return (0, jsx_runtime_1.jsx)(Component, { ...shellContext, ...props });
    };
};
exports.default = withShellContext;
